/* eslint-disable react/no-danger */
import classNames from 'classnames';
import { useCallback, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { useThemeClassName } from '../../contexts/ThemeContext';
import StyledButton from '../buttons/StyledButton';
import SportGroupsPills from '../lists/SportGroupsPills';
import Dialog from './Dialog';
import Modal from './Modal';

import styles from '../../../styles/modals/group-questions-answered.module.scss';

interface GroupQuestionsAnsweredModalProps {
    questionsGroups: QuestionGroup[];
    currentGroup: string;
    onClose?: () => void;
    className?: string;
}

function GroupQuestionsAnsweredModal({
    questionsGroups,
    currentGroup: currentGroupId,
    onClose = null,
    className = null,
}: GroupQuestionsAnsweredModalProps) {
    const themeClassName = useThemeClassName(styles);

    const [opened, setOpened] = useState(true);
    const onRequestClose = useCallback(() => {
        setOpened(false);
    }, []);

    const onClosed = useCallback(() => {
        if (onClose !== null) {
            onClose();
        }
    }, [onClose]);

    const currentGroup = questionsGroups.find(({ id }) => id === currentGroupId) || null;
    const { answeredModalTitle = null, answeredModalDescription = null } = currentGroup || {};

    return (
        <Modal opened={opened} withSafe onClickSafe={onRequestClose} onClosed={onClosed}>
            <Dialog
                className={classNames([
                    styles.container,
                    themeClassName,
                    { [className]: className !== null },
                ])}
                contentClassName={styles.content}
                closeButtonClassName={styles.closeButton}
                onClickClose={onRequestClose}
            >
                <div className={styles.inner}>
                    <SportGroupsPills
                        className={styles.periods}
                        items={questionsGroups.filter(
                            ({ type, questions: groupQuestions = [] }) =>
                                type !== 'trivia' && groupQuestions.length > 1,
                        )}
                        answeredGroup={currentGroupId}
                        isDark
                    />
                    <div className={styles.text}>
                        {answeredModalTitle !== null ? (
                            <h2
                                className={styles.title}
                                dangerouslySetInnerHTML={{ __html: answeredModalTitle }}
                            />
                        ) : null}
                        {answeredModalDescription !== null ? (
                            <p
                                className={styles.description}
                                dangerouslySetInnerHTML={{ __html: answeredModalDescription }}
                            />
                        ) : null}
                    </div>
                    <div className={styles.actions}>
                        <StyledButton className={styles.button} colored onClick={onClose}>
                            <span className={styles.label}>
                                <FormattedMessage
                                    defaultMessage="Close"
                                    description="Button label"
                                />
                            </span>
                        </StyledButton>
                    </div>
                </div>
            </Dialog>
        </Modal>
    );
}

export default GroupQuestionsAnsweredModal;
